import {createBrowserRouter} from 'react-router-dom';
// components
import ProtectedRoute from './components/ProtectedRoute';
import SignIn from './components/pages/signIn';
import SignUp from './components/pages/signUp';
import Logout from './components/pages/logout';
import RenderComponentsByRole from './components/RenderComponentsByRole';
import CoursePage from './components/pages/course';
import LessonPage from './components/pages/lesson';
import AttestationPage from './components/pages/attestation';
import GroupsComponent from './components/core/groups';
import GroupComponent from './components/core/group';
import AttestationComponent from './components/core/attestationStatistic';
import OrganisationProfiles from './components/core/organisationProfiles';
import OrganisationSettings from './components/core/organisationSettings';
import SuppervisorSupport from './components/core/supervisorSupport';
import {checkCanRead} from './utils';


// constants
import APP_URLs from './consts/url';
import StudentMainPage from './components/pages/studentMainPage';

const router = createBrowserRouter([
    {
      path: APP_URLs.MAIN,
      element: (
        <ProtectedRoute checkAccess={checkCanRead}>
          <RenderComponentsByRole />
        </ProtectedRoute>
      ),
      errorElement: <div>404 not found</div>,
      children: [
        {
          path: APP_URLs.GROUPS,
          element: <GroupsComponent/>
        },
        {
          path: `${APP_URLs.EDIT_GROUP}/:groupId`,
          element: <GroupComponent/>
        },
        {
          path: APP_URLs.MAIN,
          element: <AttestationComponent />,
        },
        {
          path: APP_URLs.ORGANISATION_SETTINGS,
          element: <OrganisationSettings />
        },
        {
          path: APP_URLs.SUPPORT,
          element: <SuppervisorSupport />,
        },
        {
          path: APP_URLs.ORGANISATION_PROFILES,
          element: <OrganisationProfiles/>
        }
      ],
    },
    {
      path: APP_URLs.SIGN_IN,
      element: <SignIn />,
    },
    {
      path: APP_URLs.SIGN_IN_ALEXANDR_EREVAN,
      element: <SignIn />,
    },
    {
      path: APP_URLs.SIGN_UP,
      element: <SignUp />,
    },
    {
      path: `${APP_URLs.STUDENT_PAGE}`,
      element: (
        <ProtectedRoute checkAccess={checkCanRead}>
          <StudentMainPage />
        </ProtectedRoute>
      ),
    },
    {
      path: `${APP_URLs.COURSE}/:courseId`,
      element: (
        <ProtectedRoute checkAccess={checkCanRead}>
          <CoursePage />
        </ProtectedRoute>
      ),
    },
    {
      path: `${APP_URLs.LESSON}/:courseId/:lessonId`,
      element: (
        <ProtectedRoute checkAccess={checkCanRead}>
          <LessonPage />
        </ProtectedRoute>
      ),
    },
    {
      path: APP_URLs.LOGOUT,
      element: <Logout />,
    },
    {
      path: `${APP_URLs.ATTESTAITON}/:attestationId`,
      element: (
        <ProtectedRoute checkAccess={checkCanRead}>
          <AttestationPage/>
        </ProtectedRoute>
      ) 
    }
]);

export default router;